(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-gallery]');
    if (!root) return;

    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    if (!slides.length) return;

    let index = slides.findIndex((el) => el.hasAttribute('data-active'));
    if (index < 0) index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((el, i) => el.toggleAttribute('data-active', i === index));
      thumbs.forEach((el, i) => el.toggleAttribute('data-active', i === index));
    };

    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', () => show(index - 1));
    if (next) next.addEventListener('click', () => show(index + 1));
    thumbs.forEach((el) => el.addEventListener('click', () => show(Number(el.dataset.galleryThumb))));

    const stage = root.querySelector('.gallery__stage');
    if (stage) {
      let startX = 0;
      let startY = 0;
      let isDragging = false;

      stage.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      stage.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const diffX = e.touches[0].clientX - startX;
        const diffY = e.touches[0].clientY - startY;
        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
          e.preventDefault();
        }
      }, { passive: false });

      stage.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        isDragging = false;
        const endX = e.changedTouches[0].clientX;
        const diff = endX - startX;
        const threshold = 50;
        if (diff < -threshold) show(index + 1);
        else if (diff > threshold) show(index - 1);
      }, { passive: true });
    }

    show(index);
  })();
  } catch(e) { console.error(e); }
})();

})();
